import type { IUser } from '@app-types/queryMutationTypes/user';

export const routeSearchParams = {
  pageStep: 'p',
} as const;

export const pagesInnerRoutes = {
  profile: {
    details: 'details',
    edit: 'edit',
  },
} as const;

export const routeParams = {
  perkEditId: ':perkEditId',
  perkViewId: ':perkViewId',
  perkIdIU: ':perkIdIU',
  groupSlug: ':groupSlug',
  brandVanityUrlOrId: ':brandVanityUrlOrId',
  brandSubCat: ':brandSubCat',
  brandPerkViewId: ':brandPerkViewId',
  perkBenefitListCat: ':perkBenefitListCat',
  perkBenefitListSubCat: ':perkBenefitListSubCat',
} as const;

// Please make sure to use unique and clear url params as now we can get them directly using "useParam" hook, avoid using duplicate params, (like, instead of "slug" for group, and category, use "groupSlug" & "categorySlug", make it unique and it will make our development work easy)
export const SHARED_ROUTES = {
  APP_ROOT_URL: '/',
  SIGN_IN_ROUTE: '/sign-in',
  SIGN_UP_ROUTE: '/sign-up',
  ONBOARDING_ROUTE: '/onboarding',
  HOME: '/dashboard',
  PROFILE: '/profile',
  INVITATIONS: '/invitations',
  PERK_INSIGHTS: '/perk-insights',
  LOGOUT: '/logout',
  PERK_MANAGEMENT: '/perk',
  PERK_APPROVAL_REQUESTS: '/perk-approval-requests',
  SINGLE_PERK: `/perk/${routeParams.perkViewId}`,
  PERK_INTERESTED_USERS: `/perk/${routeParams.perkIdIU}/interested-users`,
  PERK_APPROVAL_REQUEST_HISTORY: `/perk/${routeParams.perkIdIU}/approval-request-history`,
  SINGLE_GROUP: `/group/${routeParams.groupSlug}`,
  EDIT_PERK: `/perk/edit/${routeParams.perkEditId}`,
  CATEGORIES: '/categories',
  EMPLOYEES: '/employees',
  MERCHANTS: '/merchants',
  EDIT_EMPLOYEE_DASHBOARD: '/employee-dashboard',
  GROUPS: '/groups',
  IMPORT_EMPLOYEES: '/import-employees',
  VERIFIED_MEMBER: '/verified-member',
  INVALID_INVITE: '/invalid-invite',
  CHECKOUT_SUCCESS: '/checkout-success',
  CART: '/cart',
  PURCHASES: '/purchases',
  VERIFY_PERK_REDEEM: '/orders',
  PERKS: '/perks',
  EMPLOYERS: '/employers',
  USERS: '/users',
  MERCHANDIZE: `/organisation/${routeParams.brandVanityUrlOrId}`,
  MERCHANDIZE_SUB: `/organisation/${routeParams.brandVanityUrlOrId}/${routeParams.brandSubCat}`,
  SINGLE_PERK_BRAND: `/organisation/${routeParams.brandVanityUrlOrId}/perk/${routeParams.brandPerkViewId}`,
  NEARBY_LOCATION: '/nearby-location',
  NEARBY_LOCATION_CAT: `/nearby-location/${routeParams.perkBenefitListCat}`,
  NEARBY_LOCATION_SUB_CAT: `/nearby-location/${routeParams.perkBenefitListCat}/${routeParams.perkBenefitListSubCat}`,
  PERK_MANAGEMENT_CAT: `/${routeParams.perkBenefitListCat}`,
  PERK_MANAGEMENT_SUBCAT: `/${routeParams.perkBenefitListCat}/${routeParams.perkBenefitListSubCat}`,
  REFERRALS: '/referrals',
  SETTINGS: '/settings',
  EMAIL_DOMAINS: '/email-domains',
  BLOCK_EMAIL_EXPRESSIONS: '/block-email-expressions',
  USER_HISTORY: '/user-history',
  PERK_CATEGORIES: '/perk-categories',
  BENEFIT_CATEGORIES: '/benefit-categories',
  LANDIND_PAGE: (userData: IUser): string =>
    userData?.employerId
      ? userData?.employerId?.employeesLandingCategory?.categorySlug
        ? `/${userData?.employerId?.employeesLandingCategory?.categorySlug}`
        : SHARED_ROUTES.PERKS
      : SHARED_ROUTES.PERKS,
  EMAIL_SIGNIN_VERIFY: '/callback/verification',
  PAGE_NOT_FOUND: '/page-not-found',
  WILD_CARD: '*',
  APP_ROOT_SIGN_UP_MODAL: '/?type=signup',
  INTEGRATIONS_LIST_PAGE: '/integrations',
  PUSH_NOTIFICATIONS_PAGE: '/push-notifications',
  PUSH_NOTIFICATION_GROUPS: '/push-notification-groups',
  SINGLE_PUSH_NOTIFICATION_GROUP: '/push-notification-groups/:groupSlug',
} as const;
